import { http } from '@/shared/api';
import type { UUID } from '@/shared/types/api';

import type {
  LoginResponse,
  MiniAppLinkPayload,
  MiniAppLoginPayload,
  RequestOtpPayload,
  RequestOtpResponse,
  UpdateProfilePayload,
  User,
  VerifyOtpPayload,
} from '../types/auth.types';

/**
 * Transport for authentication and the current user's profile.
 *
 * Pure request/response functions — no caching, no React. Everything above
 * this file reaches them through the TanStack Query hooks in `./queries.ts`.
 */
export const authApi = {
  requestOtp: (payload: RequestOtpPayload) =>
    http.post<RequestOtpResponse, RequestOtpPayload>('/auth/request-otp', payload),

  verifyOtp: (payload: VerifyOtpPayload) =>
    http.post<LoginResponse, VerifyOtpPayload>('/auth/verify-otp', payload),

  /** Responds 428 when the platform shared no phone — see `miniAppLink`. */
  miniAppLogin: (payload: MiniAppLoginPayload) =>
    http.post<LoginResponse, MiniAppLoginPayload>('/auth/miniapp', payload),

  /** One-time binding of an Eitaa identity to a phone-verified account. */
  miniAppLink: (payload: MiniAppLinkPayload) =>
    http.post<LoginResponse, MiniAppLinkPayload>('/auth/miniapp/link', payload),

  getMe: () => http.get<User>('/users/me'),

  updateMe: (payload: UpdateProfilePayload) =>
    http.patch<User, UpdateProfilePayload>('/users/me', payload),

  getUser: (userId: UUID) => http.get<User>(`/users/${userId}`),
} as const;
